import { ROLES } from '@inpart-io/devtools-iap';
import { DataType, type IDealType, type InfoGroupType, InfoGroupValueType } from '@inpart-io/padme-iap';

import { ICONS_NAME } from '@/constants/ui/icons.constants';

export const SettingsAllAccessRoles = [ROLES.BUSINESS_ADMIN, ROLES.TECHNICAL_ADMIN];

export const SettingsAccessRoles = {
    FIELDS: [ROLES.TECHNICAL_ADMIN, ROLES.BUSINESS_ADMIN],
    TEMPLATES: [ROLES.TECHNICAL_ADMIN, ROLES.BUSINESS_ADMIN],
    EVALUATION_TEMPLATES: [ROLES.TECHNICAL_ADMIN],
    REPORT_TEMPLATES: [ROLES.TECHNICAL_ADMIN],
    PLATFORM: [ROLES.TECHNICAL_ADMIN, ROLES.BUSINESS_ADMIN],
    EVALUATE: [ROLES.TECHNICAL_ADMIN],
    INTEGRATIONS: [ROLES.BUSINESS_ADMIN, ROLES.TECHNICAL_ADMIN],
    FOLDERS: [ROLES.BUSINESS_ADMIN, ROLES.TECHNICAL_ADMIN],
    LAYOUT: [ROLES.BUSINESS_ADMIN, ROLES.TECHNICAL_ADMIN]
};

export const LEADS_KEY = 'LEAD_FIELDS';
export const ASSETS_KEY = 'ASSET_FIELDS';
export const AGREEMENTS_KEY = 'AGREEMENT_FIELDS';
export const ALLIANCES_KEY = 'ALLIANCE_FIELDS';
export const OTHERS_KEY = 'OTHER_FIELDS';
export const TEMPLATES_KEY = 'TEMPLATES';
export const WORKFLOWS_KEY = 'WORKFLOWS';
export const LAYOUT_KEY = 'LAYOUT';
export const PLATFORM_KEY = 'PLATFORM';
export const INTEGRATIONS_KEY = 'INTEGRATIONS';
export const FOLDERS_KEY = 'FOLDERS';

export const PlatformSettingsTabs = new Map();
PlatformSettingsTabs.set(LEADS_KEY, 'LEAD_TAB_TITLE');
PlatformSettingsTabs.set(ASSETS_KEY, 'ASSET_TAB_TITLE');
PlatformSettingsTabs.set(AGREEMENTS_KEY, 'AGREEMENT_TAB_TITLE');
PlatformSettingsTabs.set(ALLIANCES_KEY, 'ALLIANCE_TAB_TITLE');
PlatformSettingsTabs.set(OTHERS_KEY, 'OTHER_TAB_TITLE');
PlatformSettingsTabs.set(TEMPLATES_KEY, 'TEMPLATES');
PlatformSettingsTabs.set(WORKFLOWS_KEY, 'WORKFLOWS');
PlatformSettingsTabs.set(LAYOUT_KEY, 'LAYOUT_TAB_TITLE');
PlatformSettingsTabs.set(PLATFORM_KEY, 'PLATFORM');
PlatformSettingsTabs.set(INTEGRATIONS_KEY, 'INTEGRATIONS');
PlatformSettingsTabs.set(FOLDERS_KEY, 'FOLDERS_TAB_TITLE');

export interface IInfogroupCriteria {
    criteriaTarget: DataType | InfoGroupType;
    criteriaName: string;
    criteriaList?: string[];
    icon?: string;
}

export const AgreementInfoGroupValues = {
    AGREEMENT_DETAILS: 'AGREEMENT_DETAILS',
    AGREEMENT_FINANCIALS: 'AGREEMENT_FINANCIALS',
    ASSESSMENT: 'ASSESSMENT'
} as const;

const CRITERIA_DETAILS = ['CDA', 'MSA', 'MTA', 'LICENSING', 'RESEARCH', 'FELLOWSHIP', 'CONSULTANCY', 'OTHER'];
const CRITERIA_FINANCIALS = ['LICENSING', 'RESEARCH', 'FELLOWSHIP', 'CONSULTANCY'];
const CRITERIA_NAME = 'category';

export type IAgreementInfoGroupsType = keyof typeof AgreementInfoGroupValues;

export const criteriaProps = new Map<DataType | InfoGroupType, IInfogroupCriteria>([
    [
        DataType.AgreementDetail,
        {
            criteriaTarget: DataType.Agreement,
            criteriaName: CRITERIA_NAME,
            criteriaList: CRITERIA_DETAILS,
            icon: ICONS_NAME.AGREEMENT_OUTLINE
        }
    ],
    [
        InfoGroupValueType.AGREEMENT_DETAILS,
        {
            criteriaTarget: DataType.Agreement,
            criteriaName: CRITERIA_NAME,
            criteriaList: CRITERIA_DETAILS
        }
    ],
    [
        InfoGroupValueType.AGREEMENT_FINANCIALS,
        {
            criteriaTarget: DataType.Agreement,
            criteriaName: CRITERIA_NAME,
            criteriaList: CRITERIA_FINANCIALS
        }
    ]
]);

export type DealTypeCategory = IDealType & { dataType?: string; nonSelectableOption?: boolean; label?: string; disable?: boolean };
